import type { VoucherView } from '@voll-intelligence/domain';

import { t } from '@web/i18n';
import { EmptyHint } from '@web/ui/core/molecules';

import { CustomerVoucherRow } from '../components/customer_voucher_row';

/**
 * Cancelados & Expirados tab — the dossier's inactiveVouchers as the same voucher
 * rows used in Viagens, inside a single non-collapsing card. Each row opens the
 * same shared drawer via `onOpenVoucher`. Empty array renders an EmptyHint.
 */
export function CustomerInactiveTab({
  inactiveVouchers,
  onOpenVoucher,
}: Readonly<{
  inactiveVouchers: readonly VoucherView[];
  onOpenVoucher: (voucher: VoucherView) => void;
}>): React.JSX.Element {
  if (inactiveVouchers.length === 0) {
    return <EmptyHint testId="customers-inactive-empty">{t('customers.inactive.empty')}</EmptyHint>;
  }

  return (
    <ul className="overflow-hidden rounded-lg border border-border-soft bg-surface">
      {inactiveVouchers.map((voucher) => (
        <CustomerVoucherRow key={voucher.id} voucher={voucher} onOpen={onOpenVoucher} />
      ))}
    </ul>
  );
}
